import React, { useState, useEffect } from 'react'
import { T } from '../ui'
import TdLabTab from './TdLabTab'
import ScorersTab from './ScorersTab'
import TdRolesTab from './TdRolesTab'
import DueTab from './DueTab'
import ValueTdsTab from './ValueTdsTab'
import { track } from '../track'

// Touchdowns — one home for "who scores?". These used to be four separate screens (Pay Dirt,
// TD Scorers, TD Matchups, Due) reached from different places; each view is the same component
// as before, so nothing is lost — they're just one tap apart under a single tab.
export const TD_VIEWS = [
  { id: 'paydirt',  label: 'Pay Dirt',    desc: 'Best red-zone TD setups — role, matchup and price, with a graded record.' },
  { id: 'likely',   label: 'Most likely', desc: 'Everyone ranked by chance to score — by game, team or overall.' },
  { id: 'value',    label: 'Value',       desc: 'Value touchdown plays — 25–45% to score, a soft matchup, and a price worth a look.' },
  { id: 'matchups', label: 'Matchups',    desc: 'Defenses that give up TDs to a player’s role (top WR, lead RB, top TE…).' },
  { id: 'due',      label: 'Due',         desc: 'Big usage, no TD lately — still projected to score.' },
]

export default function TouchdownsTab({ season, week, onPlayer, onAddLeg, slipKeys, gameFilter, initial = 'paydirt' }) {
  const [view, setView] = useState(initial)
  useEffect(() => { setView(initial) }, [initial])
  const cur = TD_VIEWS.find(v => v.id === view) || TD_VIEWS[0]
  return (
    <div>
      <div style={{ padding: '12px 16px 0' }}>
        <div role="tablist" aria-label="Touchdown views" style={{ display: 'grid', gridTemplateColumns: `repeat(${TD_VIEWS.length}, 1fr)`,
          gap: 4, background: T.card2, border: `1px solid ${T.border}`, borderRadius: 11, padding: 3 }}>
          {TD_VIEWS.map(v => {
            const on = v.id === cur.id
            return (
              <button key={v.id} role="tab" aria-selected={on} onClick={() => { track('td_view', v.id); setView(v.id) }} style={{ cursor: 'pointer',
                border: 'none', borderRadius: 8, padding: '8px 2px', fontSize: 12, fontWeight: 800, whiteSpace: 'nowrap',
                color: on ? '#04140D' : T.muted, background: on ? T.green : 'transparent' }}>{v.label}</button>
            )
          })}
        </div>
        {/* Pay Dirt carries its own header; the other views get a one-line "what is this". */}
        {cur.id !== 'paydirt' && cur.id !== 'value' && <div style={{ fontSize: 11.5, color: T.muted, lineHeight: 1.45, padding: '8px 2px 0' }}>{cur.desc}</div>}
      </div>
      {cur.id === 'paydirt' && <TdLabTab season={season} week={week} onPlayer={onPlayer} onAddLeg={onAddLeg} slipKeys={slipKeys} hideDue gameFilter={gameFilter} />}
      {cur.id === 'likely' && <ScorersTab season={season} week={week} onPlayer={onPlayer} gameFilter={gameFilter} />}
      {cur.id === 'value' && <ValueTdsTab season={season} week={week} onPlayer={onPlayer} gameFilter={gameFilter} />}
      {cur.id === 'matchups' && <TdRolesTab season={season} week={week} onPlayer={onPlayer} gameFilter={gameFilter} />}
      {cur.id === 'due' && <DueTab season={season} week={week} onPlayer={onPlayer} gameFilter={gameFilter} />}
    </div>
  )
}
